<template>
  <div class="interaction">
    <div
      v-infinite-scroll="load"
      class="timeline-wrapper"
      :infinite-scroll-immediate="false"
    >
      <template v-if="timelineList.length > 0">
        <mk-timeline>
          <mk-timeline-item
            v-for="(item, index) in timelineList"
            :key="index"
            hide-timestamp
            placement="top"
          >
            <div class="main-time">
              {{ item.formatDate }}
            </div>
            <div class="title">
              <img
                v-if="item.platform === 'MINI'"
                src="@/assets/images/minipro.png"
              >
              <img
                v-else
                src="@/assets/images/h5.png"
              >
              <template v-if="item.event === 'grant'">
                授权了自己的手机号码
              </template>
              <template v-else>
                {{ item.behavior }}<span class="material-title-color">{{
                  item.userName.substring(0, item.userName.length - 1)
                }}</span>的{{ item.materialCn }}
                <template v-if="item.stayTime">
                  ，{{ item.tips }}停留了{{ item.stayTime }}秒
                </template>
              </template>
            </div>
            <div class="tag">
              <div
                class="clue-all-tag"
              >
                <template v-if="item.tagOverview && item.tagOverview.length > 0">
                  <mk-tag
                    v-for="(tag, tagIndex) in item.tagOverview.slice(0, 3)"
                    :key="tagIndex"
                    class="tag-margin"
                  >
                    <!-- 兼容之前老数据，老数据没有分数，显示+1 -->
                    {{ tag.tName }}+{{ tag.tagScore ? tag.tagScore : 1 }}
                  </mk-tag>
                  <tag-popover
                    v-if="item.tagOverview.length > 3"
                    :tag-list="item.tagOverview"
                    class="tag-margin"
                  ></tag-popover>
                </template>
              </div>
              <div
                v-if="item.fromPerson"
                class="from"
                :style="{'margin-top': (item.tagOverview && item.tagOverview.length > 0) ? '0' : '-20px'}"
              >
                来自：{{ item.fromPersonCn }}
              </div>
            </div>
            <div class="more-info">
              <div
                v-for="(otherItem, otherIndex) in item.subActivity"
                :key="otherIndex"
                class="other-info-item"
              >
                <div>
                  <div class="other-info-time">
                    {{
                      otherItem.triggerTime && otherItem.triggerTime.slice(10, 16)
                    }}
                  </div>
                  <div
                    v-if="otherItem.eventCn"
                    class="other-info-action"
                  >
                    <!-- {{ otherItem.eventCn }} -->
                    <template v-if="otherItem.event === 'grant'">
                      授权了自己的手机号码
                    </template>
                    <p
                      v-else
                      style="display:inline-block;"
                      v-html="otherItem.eventCn"
                    ></p>
                    <!-- 事件为提交表单时候，需要特殊处理，跳转到表单数据页面 -->
                    <template v-if="otherItem.event === 'submitForm'">
                      ，<router-link
                        :to="{
                          path:
                            '/marketing-content/marketing-data/statistical-data',
                          query: {
                            id: otherItem.materialInfo[0]._id,
                            type: 'form',
                            isForm: '1'
                          }
                        }"
                        class="cursor view-form"
                      >
                        查看表单
                      </router-link>
                    </template>
                    <div
                      v-if="otherItem.subActivity && otherItem.subActivity.length > 0"
                      class="third-event-action"
                    >
                      <mk-timeline
                        v-if="otherItem.active"
                        class="mk-timeline-event"
                      >
                        <mk-timeline-item
                          v-for="(iItem,iIndex) in otherItem.subActivity"
                          :key="iIndex"
                          hide-timestamp
                          placement="top"
                        >
                          <div class="third-event-list-detail">
                            <div>
                              <span>{{ iItem.triggerTime && iItem.triggerTime.slice(10, 16) }}</span>
                              <br>
                              <template v-if="otherItem.event === 'grant'">
                                授权了自己的手机号码
                              </template>
                              <template v-else>
                                {{ iItem.eventCn }}
                              </template>
                            </div>
                            <div
                              v-if="iItem.tagOverview && iItem.tagOverview.length > 0"
                              class="other-info-tag third-info-tag"
                            >
                              <mk-tag
                                v-for="(iTag, iTagIndex) in iItem.tagOverview.slice(0, 3)"
                                :key="iTagIndex"
                                class="other-info-tag-item third-info-tag-item"
                              >
                                {{ iTag.tName }}+{{ iTag.tagScore }}
                              </mk-tag>
                              <tag-popover
                                v-if="iItem.tagOverview.length > 3"
                                :tag-list="iItem.tagOverview"
                              ></tag-popover>
                            </div>
                          </div>
                        </mk-timeline-item>
                      </mk-timeline>
                    </div>
                  </div>
                </div>
                <div
                  class="other-info-tag"
                >
                  <mk-tag
                    v-for="(otherTag,otherTagIndex) in otherItem.tagOverview.slice(0, 3)"
                    :key="otherTagIndex"
                    class="other-info-tag-item"
                  >
                    {{ otherTag.tName }}+{{ otherTag.tagScore }}
                  </mk-tag>
                  <tag-popover
                    v-if="otherItem.tagOverview.length > 3"
                    :tag-list="otherItem.tagOverview"
                  ></tag-popover>
                  <div
                    v-if="otherItem.subActivity.length > 0"
                    class="expand"
                    @click="otherItem.active = !otherItem.active"
                  >
                    <i
                      v-if="!otherItem.active"
                      class="el-icon-arrow-down"
                    ></i>
                    <i
                      v-if="otherItem.active"
                      class="el-icon-arrow-up"
                    ></i>
                  </div>
                </div>
              </div>
            </div>
          </mk-timeline-item>
        </mk-timeline>
      </template>
      <template v-else>
        <template v-if="!loading">
          暂无互动数据
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import {
  eventFormat,
  personFormat,
  materialFormat,
  commonMaterial,
  platformFormat,
  formatInfo,
  operateEntity,
  operateMiniMaterialType
} from '@/utils/userActionFormat'
import TagPopover from '@/components/tag-popover'
export default {
  name: 'Interaction',
  components: {
    TagPopover
  },
  props: {
    // 线索的id
    unionId: {
      type: String,
      default: ''
    },
    // 列表userId
    userId: {
      type: String,
      default: ''
    },
    ev: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      // 是否正在加载
      loading: false,
      // 时间轴数据
      timelineList: [],
      // 当前页码
      page: 1,
      // 总页数
      totalPage: 0
    }
  },
  mounted () {
    this.wxclueShowActivityGet(1)
  },
  methods: {
    // 页码改变
    // 查询微信线索详细-互动
    async wxclueShowActivityGet (page) {
      let params = {
        page: page,
        pageSize: 5,
        unionId: this.unionId
        // userId: this.userId
      }
      this.loading = true
      this.$emit('loading', true)
      let res = await CLUEAPIS.ClueApi.clueMkActivityGet(params)
      if (res.success) {
        const { data } = res
        let dataList = data.list
        const userNameMap = await this.getUserNameMap()
        let list = []
        dataList.forEach(async item => {
          if (item.subActivity.length === 1) {
            list.push({
              ...item.subActivity[0],
              listLevel: 2
            })
          } else {
            list.push(item)
          }
        })

        list.forEach(async item => {
          let userName = userNameMap[item.userId]
            ? userNameMap[item.userId]
            : ''
          item.userName = personFormat(userName)

          item.behavior = formatInfo(item)

          if (item.platform !== 'WPN' && item.listLevel !== 2) item.tips = '在小程序中'

          if (item.operateEntity === 'material') {
            let material = materialFormat(
              item.materialInfo[0].type
            )
            item.materialCn = `${material}《${item.materialInfo[0].title}》`
          } else if (item.operateEntity === 'commonMaterial') {
            let material = commonMaterial(
              item.commonMaterialInfo[0].type
            )
            item.materialCn = `${material}《${item.commonMaterialInfo[0].title}》`
          } else if (item.operateEntity === 'miniMaterial') {
            // let material = operateMiniMaterialType(
            //   item.miniMaterialInfo[0].type
            // )
            let material = '文件'
            item.materialCn = `${material}《${item.miniMaterialInfo[0].title}》`
          } else {
            item.materialCn = operateEntity(item.operateEntity)
          }
          this.formatDate(item)
          item.subActivity.forEach(innerItem => {
            let eventCn = ''
            eventCn += formatInfo(innerItem)
            if (innerItem.operateEntity === 'material') {
              // 不要删除此段代码
              if (item.listLevel !== 2) {
                if (innerItem.event === 'enterPage' || innerItem.event === 'enterPage' || innerItem.event === 'leavePage') {
                  if (item.operateEntity === 'material' && (item.subActivity.length === 0)) {
                    eventCn += '页面'
                  } else {
                    if (item.operateEntity === 'material' && innerItem.operateEntity === 'material') {
                      eventCn += '页面'
                    } else {
                      eventCn += `${materialFormat(
                        innerItem.materialInfo[0].type
                      )}《${innerItem.materialInfo[0].title}》`
                      if (innerItem.stayTime) eventCn += `，停留了${innerItem.stayTime}秒`
                    }
                  }
                } else {
                  if ((innerItem.event === 'share')) {
                    eventCn += `${materialFormat(innerItem.materialInfo[0].type)}《${innerItem.materialInfo[0].title}》`
                  }
                  if ((innerItem.event === 'leavePage')) {
                    eventCn += '页面'
                  }
                }
              } else {
                if ((innerItem.event === 'share' || innerItem.event === 'enterPage' || innerItem.event === 'leavePage')) {
                  eventCn += '页面'
                }
              }
              // 不要删除此段代码
              // if ((innerItem.event === 'share' || innerItem.event === 'enterPage' || innerItem.event === 'leavePage')) {
              //   eventCn += '页面'
              // }
              innerItem.eventCn = eventCn
            } else if (innerItem.operateEntity === 'commonMaterial') {
              eventCn += `${commonMaterial(
                innerItem.commonMaterialInfo[0].type
              )}《${innerItem.commonMaterialInfo[0].title}》`
              if (innerItem.stayTime) eventCn += `，停留了${innerItem.stayTime}秒`
              innerItem.eventCn = eventCn
            } else if (innerItem.operateEntity === 'miniMaterial') {
              // eventCn += `${operateMiniMaterialType(
              //   innerItem.miniMaterialInfo[0].type
              // )}《${innerItem.miniMaterialInfo[0].title}》，停留了${innerItem.stayTime}秒`
              let id = JSON.parse(window.localStorage.getItem('user')).id
              if (innerItem.userId === id) {
                eventCn += `<span style="color:#009cff">你</span>的`
                eventCn += `文件《${innerItem.miniMaterialInfo[0].title}》`
                if (innerItem.stayTime) eventCn += `，停留了${innerItem.stayTime}秒`
                this.timelineList = this.timelineList.concat([])
                innerItem.eventCn = eventCn
              } else {
                let that = this
                this.getUser(innerItem.userId).then((data) => {
                  if (data && data.name) {
                    eventCn += `<span style="color:#009cff">${data && data.name}</span>的`
                  } else {
                  }
                  eventCn += `文件《${innerItem.miniMaterialInfo[0].title}》`
                  if (innerItem.stayTime) eventCn += `，停留了${innerItem.stayTime}秒`
                  this.timelineList = this.timelineList.concat([])
                  innerItem.eventCn = eventCn
                })
              }
              innerItem.eventCn = eventCn
            } else {
              if (innerItem.operateEntity === 'card') {
                if (innerItem.cardInfo[0] && innerItem.cardInfo[0].name) {
                  eventCn += `<span style="color:#009cff">${(innerItem.cardInfo[0] && innerItem.cardInfo[0].name)}</span>的`
                  // eventCn += operateEntity(innerItem.operateEntity)
                  // innerItem.eventCn = eventCn
                } else {
                  // this.getUser(item.userId).then((data) => {
                  //   eventCn += `<span style="color:#009cff">${data && data.name}</span>的`
                  //   this.timelineList = this.timelineList.concat([])
                  //   innerItem.eventCn = eventCn
                  //   eventCn += operateEntity(innerItem.operateEntity)
                  //   innerItem.eventCn = eventCn
                  // }).catch((error) => {
                  // })
                  eventCn += `销售的`
                }
                eventCn += operateEntity(innerItem.operateEntity)
                innerItem.eventCn = eventCn
              } else {
                let id = JSON.parse(window.localStorage.getItem('user')).id
                if (innerItem.userId === id) {
                  eventCn += `<span style="color:#009cff">你</span>的`
                  eventCn += operateEntity(innerItem.operateEntity)
                  this.timelineList = this.timelineList.concat([])
                  innerItem.eventCn = eventCn
                } else {
                  let that = this
                  this.getUser(innerItem.userId).then((data) => {
                    eventCn += `<span style="color:#009cff">${data && data.name}</span>的`
                    eventCn += operateEntity(innerItem.operateEntity)
                    this.timelineList = this.timelineList.concat([])
                    innerItem.eventCn = eventCn
                  })
                }
              }
            }

            if (innerItem.subActivity instanceof Array) {
              innerItem.active = false
              innerItem.subActivity.forEach(iItem => {
                let eventCn = ''
                eventCn += formatInfo(iItem)
                if ((iItem.event === 'share' || iItem.event === 'enterPage' || iItem.event === 'leavePage') && iItem.operateEntity === 'material') {
                  eventCn += '页面'
                }
                if (iItem.operateEntity !== 'material' && iItem.operateEntity !== 'commonMaterial') {
                  eventCn += operateEntity(iItem.operateEntity)
                }
                iItem.eventCn = eventCn
              })
            }
          })

          // 转发/分享人是谁
          if (item.secondScene === '0') {
            let userId = item.shareActionInfo
              ? item.shareActionInfo.userId
              : item.userId
            item.fromPerson = userNameMap[userId] || ''
            item.fromPersonCn = item.fromPerson + '的分享'
          } else if (item.secondScene === '1') {
            item.fromPerson = item.forwardClueName
            item.fromPersonCn = item.fromPerson + '的转发'
          } else {
            item.fromPerson = '自主访问'
            item.fromPersonCn = '自主访问'
          }
          // if (item.saleShare === false) {
          //   item.fromPerson = item.forwardClueName
          //   item.fromPersonCn = item.fromPerson + '的转发'
          // } else {
          //   let userId = item.shareActionInfo
          //     ? item.shareActionInfo.userId
          //     : item.userId
          //   item.fromPerson = userNameMap[userId] || ''
          //   item.fromPersonCn = item.fromPerson + '的分享'
          // }
        })
        this.$emit('loading', false)
        this.timelineList = [...this.timelineList, ...list]
        this.total = data.total
        this.totalPage = Math.ceil(data.total / data.pageSize)
        this.loading = false
      }
    },
    async getUser (userId) {
      let saleInfo = await this.$DexiePlguin.getUserById(userId)
      return saleInfo
    },
    // 无限滚动加载
    load () {
      if (this.page < this.totalPage && !this.loading) {
        this.wxclueShowActivityGet(++this.page)
      }
    },
    // 获取所有的user信息，并组装为map结构
    async getUserNameMap () {
      let user = await this.$DexiePlguin.getAllUser()
      let userNameMap = {}
      user.forEach(item => {
        userNameMap[item._id] = item.name
      })
      return userNameMap
    },
    formatDate (item) {
      let year = dayjs(new Date()).format('YYYY')
      let day = dayjs(new Date()).format('DD')
      let ym = dayjs(new Date()).format('YYYY-MM')
      let ymd = dayjs(new Date()).format('YYYY-MM-DD')
      let hm = item.triggerTime.slice(10, 16)
      let itemDay = item.day.slice(8, 10)
      if (item.day === ymd) {
        item.formatDate = `今天 ${hm}`
      } else if (item.month === ym && day - itemDay === 1) {
        item.formatDate = `昨天 ${hm}`
      } else if (item.year === year) {
        item.formatDate = `${item.day.slice(5, 10)} ${hm}`
      } else {
        item.formatDate = `${item.day} ${hm}`
      }
    },
    userActionFormat (item) {
      let userInfo = JSON.parse(window.localStorage.getItem('user'))
      let platform, userName, material, event, title
      platform = platformFormat(item.platform)
      userName = personFormat(userInfo.name, item.userName)
      material = materialFormat(item.materialType, item.materialSourceType)
      event = eventFormat(item.event)
      title = item.material.title
      item.userAction = `${event}${userName} ${platform}/${material}`
      item.materialTypeName = `《${title}》`
    }
  }
}
</script>

<style lang="scss" scoped>
.interaction {
  padding: 10px;
  // height: calc(100% - 20px);

  /deep/ .mk-tag {
    display: flex;
    align-items: center;
  }

  /deep/ .mk-timeline {
    background-color: transparent;

    .el-timeline-item__content {
      font-size: 13px;

      span {
        color: #888;
        font-size: 12px;
        line-height: 17px;
      }
    }
  }

  /deep/ .show-more-button {
    cursor: pointer;
  }

  .expand {
    width: 20px;
    height: 20px;
    color: #8f9fb3;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: transparent;
    border: 1px solid transparent;
    cursor: pointer;

    &:hover {
      color: #009cff;
      background-color: #e6efff;
      border: 1px solid #d5e3ff;
    }
  }

  .mk-timeline-event {
    margin: 10px 0;
  }

  .timeline-wrapper {
    background-color: #fff;
    padding: 15px 30px 15px 15px;
  }

  .main-time {
    color: #888;
    font-size: 12px;
    line-height: 17px;
  }

  .title {
    margin-top: 5px;
    color: #262626;
    font-size: 13px;
    display: flex;
    align-items: center;

    img {
      width: 15px;
      margin-right: 8px;
    }

    .material-title-color {
      color: #009cff !important;
    }
  }

  .tag {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .clue-all-tag {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
    }

    .from {
      font-size: 13px;
      color: #888;
    }
  }

  .more-info {
    margin-top: 12px;

    .el-timeline-item {
      padding-bottom: 0;
    }

    .other-info-item {
      display: flex;
      justify-content: space-between;
      // align-items: center;
      box-sizing: border-box;
      padding: 0 15px 8px 15px;
      // height: 52px;
      background-color: #fafafa;
      border-bottom: 1px solid #fff;

      .other-info-time {
        color: #888;
        font-size: 12px;
        line-height: 17px;
        margin-top: 4px;
      }

      .other-info-action {
        margin-top: 5px;
        color: #262626;
        font-size: 13px;
        line-height: 18px;

        .view-form {
          text-decoration: none;
          color: #009cff;
        }
      }

      .from-scene {
        font-size: 13px;
        color: #888;
      }

      .other-info-tag {
        display: flex;
        height: 22px;
        align-items: center;
        margin: 22px 0 0 10px;

        .other-info-tag-item:not(:last-child) {
          margin-right: 10px;
        }
      }
    }
  }

  .tag-margin {
    margin: 10px 12px 0 0;
  }

  .interaction-pagination {
    margin-bottom: 30px;
  }

  .mk-tag {
    height: 22px;
    line-height: 22px;
    border-radius: 2px;
    padding: 0 8px;
    background: rgba(235, 239, 244, 1);
    color: #6b7b88;
    border: none;
  }

  .third-event-list-detail {
    position: relative;
    display: flex;
    // justify-content: space-between;
  }

  /deep/ .el-timeline-item__wrapper {
    padding-bottom: 10px;
  }

  .third-info-tag {
    margin-top: 16px !important;
  }

  /deep/ .el-timeline-item__tail {
    border-left: 1px solid #a0daff !important;
  }

  /deep/ .el-timeline-item__node--normal {
    left: 0 !important;
    width: 10px !important;
    height: 10px !important;
    background: #afdefc !important;
    border: 1px solid #009cff !important;
  }

  .third-event-action {
    margin: 20px 0 -20px 0;
  }
}
</style>
